<template>
  <section class="Panel">
    <div class="Panel__section">
      <div class="Panel__header" v-if="title || subtitle">
        <p class="Panel__title" v-if="title">{{title}}</p>
        <p class="Panel__subtitle" v-if="subtitle">{{subtitle}}</p>
      </div>
      <div class="Panel__content">
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String
  }
};
</script>

<style lang="stylus" src="./style.styl"></style>
